import { Select } from "@mantine/core";
import { BaseSelectStylesNames } from "@mantine/core/lib/Select/types";
import { useField } from ".";

type Props = {
  name: string;
  label?: string;
  placeholder: string;
  disabled?: boolean;
  onChange?: (value: string | null) => void;
  noError?: boolean;
  options: { value: string; label: string }[];
  clearable?: boolean;
  classNames?: Partial<Record<BaseSelectStylesNames, string>> | undefined;
  searchable?: boolean;
  onSearchChange?: any;
  icon?: any;
  itemComponent?: any;
  getCreateLabel?: any;
  onCreate?: any;
  creatable?: boolean;
  withAsterisk?: boolean;
};

export function SelectField({
  name,
  label,
  placeholder,
  noError = false,
  onChange: onChangeValue,
  options = [],
  disabled = false,
  classNames,
  clearable = true,
  searchable,
  onSearchChange,
  icon,
  itemComponent,
  getCreateLabel,
  onCreate,
  creatable,
  withAsterisk = true,
}: Props) {
  const { value, error, onChange } = useField(name);
  let temp = "";

  return (
    <Select
      icon={icon}
      label={label}
      placeholder={placeholder}
      value={value}
      disabled={disabled}
      searchable={searchable}
      onChange={(value) => {
        onChange(value);
        onChangeValue && onChangeValue(value);
      }}
      creatable={creatable}
      error={error}
      required
      clearable={clearable}
      data={options}
      style={{ flex: 1 }}
      classNames={classNames}
      itemComponent={itemComponent}
      onSearchChange={(e) => {
        if (searchable && e && temp !== e) {
          onSearchChange && onSearchChange(e);
          temp = e;
        }
      }}
      styles={{
        error: {
          display: noError ? "none" : "block",
        },
        wrapper: {
          marginBottom: noError && error && 0,
        },
      }}
      getCreateLabel={getCreateLabel}
      onCreate={onCreate}
      withAsterisk={withAsterisk}
    />
  );
}
